import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './layout/Layout';
import ProtectedRoute from './ProtectedRoute';
import LoadingSpinner from './LoadingSpinner';

// Lazy load pages for better performance
const Dashboard = lazy(() => import('../pages/Dashboard'));
const PartsInventory = lazy(() => import('../pages/PartsInventory'));
const Categories = lazy(() => import('../pages/Categories'));
const Locations = lazy(() => import('../pages/Locations'));
const Suppliers = lazy(() => import('../pages/Suppliers'));
const StockMovements = lazy(() => import('../pages/StockMovements'));
const Reports = lazy(() => import('../pages/Reports'));
const Invoices = lazy(() => import('../pages/Invoices'));
const DatabaseTest = lazy(() => import('./DatabaseTest'));

const Settings = () => (
  <div className="text-center py-12">
    <h2 className="text-2xl font-bold text-gray-900 mb-4">Settings</h2>
    <p className="text-gray-600">Settings page coming soon...</p>
  </div>
);

const AppRouter: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Suspense fallback={<LoadingSpinner size="lg" text="Loading page..." />}>
          <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          {/* Dashboard - accessible to all authenticated users */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Parts Management - requires parts permissions */}
          <Route 
            path="/parts" 
            element={
              <ProtectedRoute requiredPermission="parts.read">
                <PartsInventory />
              </ProtectedRoute>
            } 
          />
          
          {/* Categories Management - requires categories permissions */}
          <Route 
            path="/categories" 
            element={
              <ProtectedRoute requiredPermission="categories.read">
                <Categories />
              </ProtectedRoute>
            } 
          />
          
          {/* Locations Management - requires locations permissions */}
          <Route 
            path="/locations" 
            element={
              <ProtectedRoute requiredPermission="locations.read">
                <Locations />
              </ProtectedRoute>
            } 
          />
          
          {/* Suppliers Management - requires suppliers permissions */}
          <Route 
            path="/suppliers" 
            element={
              <ProtectedRoute requiredPermission="suppliers.read">
                <Suppliers />
              </ProtectedRoute>
            } 
          />
          
          {/* Stock Movements - requires stock permissions */}
          <Route 
            path="/movements" 
            element={
              <ProtectedRoute requiredPermission="stock.read">
                <StockMovements />
              </ProtectedRoute>
            } 
          />
          
                 {/* Reports - requires reports permissions */}
                 <Route
                   path="/reports"
                   element={
                     <ProtectedRoute requiredPermission="reports.read">
                       <Reports />
                     </ProtectedRoute>
                   }
                 />

                 {/* Invoices - requires reports permissions */}
                 <Route
                   path="/invoices"
                   element={
                     <ProtectedRoute requiredPermission="reports.read">
                       <Invoices />
                     </ProtectedRoute>
                   }
                 />
          
          {/* Settings - admin only */}
          <Route 
            path="/settings" 
            element={
              <ProtectedRoute 
                requiredPermissions={['users.read', 'users.update']}
                requireAll={false}
                customAccessDeniedMessage="Settings are only accessible to administrators."
              >
                <Settings />
              </ProtectedRoute>
            } 
          />
          
                 {/* Database Test - for debugging */}
                 <Route
                   path="/database-test"
                   element={
                     <ProtectedRoute>
                       <DatabaseTest />
                     </ProtectedRoute>
                   }
                 />



          
          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
};

export default AppRouter;
